import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "input-container" }
const _hoisted_3 = ["value"]
const _hoisted_4 = { class: "message-container" }
const _hoisted_5 = { key: 0 }

import { useI18n } from 'vue-i18n'
import { format } from 'date-fns'
import { computed, ref } from 'vue'
import { LOCALES } from '@/utils/locales'


export default /*@__PURE__*/_defineComponent({
  __name: 'InputCalendarDate',
  props: {
  // eslint-disable-next-line vue/require-default-prop
  inputValue: {
    required: false,
    type: String
  },
  // eslint-disable-next-line vue/require-default-prop
  formattedValue: {
    required: false,
    type: String
  },
  // eslint-disable-next-line vue/require-default-prop
  error: {
    required: false,
    type: String
  }
},
  emits: ["inputValueChanged"],
  setup(__props) {

const { locale } = useI18n()
const props = __props

const isFocused = ref(false)

function onFocusIn() {
  isFocused.value = true
}
function onFocusOut() {
  isFocused.value = false
}

const value = computed(() => {
  if (isFocused.value) {
    return props.inputValue
  } else {
    return props.inputValue ? formatDateString(props.inputValue) : props.inputValue
  }
})


function formatDateString(value: string) {
  const date = new Date(value)
  const formatting = 'dd MMM yyyy'
  const options = { locale: LOCALES[locale.value] }

  const capitalized = format(date, formatting, options).charAt(0).toUpperCase()
  const lowercased = format(date, formatting, options).slice(1)
  return capitalized + lowercased
}

const styling = computed<string>(() => {
  return !!props.error ? 'error' : ''
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("input", {
        value: value.value,
        placeholder: "yyyy-mm-dd",
        class: _normalizeClass([styling.value]),
        onFocusin: onFocusIn,
        onFocusout: onFocusOut,
        onInput: _cache[0] || (_cache[0] = (event) => _ctx.$emit('inputValueChanged', event.target.value))
      }, null, 42, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (__props.error)
        ? (_openBlock(), _createElementBlock("label", _hoisted_5, _toDisplayString(__props.error), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})